<template>
	<div>
		<subComponents  ref="showSelectData"></subComponents>
		<el-dialog :title="dataActionBox.boxTitle" :visible.sync="dataActionBox.showStatus" center :append-to-body="true" :close-on-click-modal="false">
			<el-form :model="sendDataInfo" v-if="formData" label-width="120px" size="mini">
				<el-row>
					<el-col :span="12" v-for="(formOneValue,formOneKey) in formData.jurconfigform" :key="formOneKey">
						<el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow==1" 
							:rules="formOneValue.isRequired == 1 ? [{required: true, message: '不能为空', trigger: ['blur', 'change']}] : []" >
							<!-- 系统字段 -->
							<div v-if="formOneValue.isReserved == 0">
								
								<el-popover  placement="right"  width="900" v-model="selectDataTable"  trigger="focus" v-if="formOneValue.entityField == 'bgmInternalcode'">
									<purchaseGoodsTemplate @selectDataAction="selectDataAction" ref="purchaseGoodsTemplate"></purchaseGoodsTemplate>
									<el-input  slot="reference"  v-model="sendDataInfo.bgmName"  :maxlength="$store.state.inputLength"
										@input="$refs['purchaseGoodsTemplate'][0].searchNames(sendDataInfo.bgmName)">
									</el-input>
								</el-popover>
								
								
								<!-- 数量 -->
								<el-input  @input="calculatePrice(5)" v-else-if="formOneValue.entityField == 'pspdPsnumber'"  
									:maxlength="$store.state.inputLength" type="number"
									v-model="sendDataInfo[formOneValue.entityField]">
								</el-input>
								
								<!-- 单价 -->
								<el-input  @input="calculatePrice(1)"  v-else-if="formOneValue.entityField == 'pspdPrice'"  
									:maxlength="$store.state.inputLength" type="number"
									v-model="sendDataInfo[formOneValue.entityField]" >
								</el-input>
								
								<!-- 含税价 -->
								<el-input  @input="calculatePrice(2)"  v-else-if="formOneValue.entityField == 'pspdPsprice'" 
									:maxlength="$store.state.inputLength" type="number"
									v-model="sendDataInfo[formOneValue.entityField]" >
								</el-input>
								
								<!-- 金额 -->
								<el-input  @input="calculatePrice(3)"  v-else-if="formOneValue.entityField == 'pspdMoney'" 
									:maxlength="$store.state.inputLength" type="number"
									v-model.number="sendDataInfo[formOneValue.entityField]" >
								</el-input>
								
								<!-- 含税金额 -->
								<el-input  @input="calculatePrice(4)" v-else-if="formOneValue.entityField == 'pspdPsmoney'" 
									:maxlength="$store.state.inputLength" type="number"
									v-model.number="sendDataInfo[formOneValue.entityField]" >
								</el-input>
								
								<!-- 库房 -->
								<el-select v-else-if="formOneValue.entityField == 'stId'" v-model="sendDataInfo[formOneValue.entityField]">
								    <el-option v-for="(storageRoomValue,storageRoomKey) in storageRoomList" :key="storageRoomKey" :label="storageRoomValue.stName" 
										:value="storageRoomValue.stId">
								    </el-option>
								</el-select>
																
								<el-input v-else  v-model.trim="sendDataInfo[formOneValue.entityField]" :disabled="true"></el-input>
								
							</div>
							<!-- 扩展字段 -->
							<div v-if="formOneValue.isReserved == 1">
								
								<!-- 自填 -->
								<el-input v-model.trim="sendDataInfo[formOneValue.entityField]" v-if="formOneValue.operatType == 0">
								</el-input>
								<!-- 选择数据来源 -->
								<el-input v-model.trim="sendDataInfo[formOneValue.entityField]"  v-else  
									@focus="$refs['showSelectData'].openBox(formOneValue.dsmName,formOneValue.entityField,formOneValue.dsmField)">
								</el-input>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
				
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dataActionBox.showStatus = false">取 消</el-button>
				<el-button type="primary" @click="sendDataAction()">确 定</el-button>
			</div>
		</el-dialog>
	</div>
	
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from 'number-precision'

  import purchaseGoodsTemplate from "@/components/purchaseGoodsTemplate.vue";
export default {
	name:'purchasePlanDetails',
	// props:['formData'],
    //import引入的组件需要注入到对象中才能使用
    components: {purchaseGoodsTemplate},
    data() {
        //这里存放数据
        return {
			selectDataTable:false,
			
			dataActionBox:{
				showStatus:false,
				openMode:'ltr'||'rtl',
				boxTitle:'新增'||'编辑',
				actionType:0, // 0新增，1修改
			},
			sendDataInfo:{
				"bgmInternalcode":'',
				bgmName:'',
				bgmManufacturer:'',
				bgmSpecifications:'',
				bgmPlaceorigin:'',
				"pspdIntaxrate":'',
				"pspdMoney":0,
				"pspdPrice":0,
				"pspdPsdvolume":'',
				"pspdPslowerlimit":'',
				"pspdPsmoney":0,
				"pspdPsnumber":0,
				"pspdPsnvolume":'',
				"pspdPsownumber":'',
				"pspdPsprice":0,
				"pspdPsupperlimit":'',
				"pspdReserves1": "",
				"pspdReserves2": "",
				"pspdReserves3": "",
				"pspdReserves4": "",
				"pspdReserves5": "",
				"pspdReserves6": "",
				"pspmId":'',
				"stId":''
			},
			formData:{},
			
        };
    },
    //监听属性 类似于data概念
    computed: {
	},
    //监控data中的数据变化
    watch: {
	},
    //方法集合
    methods: {
		
		// 计算价格
		calculatePrice(cate=1){
			var info = this.sendDataInfo
			if(info.pspdPsnumber<=0){
				this.$message({
					message: '请先填写建议采购数量',
					type: 'error'
				});
				return false
			}
			
			
			switch(cate){
				case 1:  // 单价计算
					
					// 计算含税价格 单价+单价*税率/100
					var thisPrice = NP.plus(info.pspdPrice,NP.divide(NP.times(info.pspdPrice,info.pspdIntaxrate),100))
					this.sendDataInfo.pspdPsprice  =  this.$common.getDecimalInfo(2,thisPrice)
					
					// 计算金额 单价*数量
					this.sendDataInfo.pspdMoney  =  this.$common.getDecimalInfo(3,NP.times(info.pspdPrice,info.pspdPsnumber))
					
					// 计算含税金额 含税价格*数量
					this.sendDataInfo.pspdPsmoney  =   this.$common.getDecimalInfo(3,NP.times(thisPrice,info.pspdPsnumber))
					
					break;
				case 2:  // 含税价格计算
					
					// 计算单价 含税价格/(税率/100+1)
					var thisPrice = NP.divide(info.pspdPsprice,NP.plus(NP.divide(info.pspdIntaxrate,100),1))
					this.sendDataInfo.pspdPrice  =  this.$common.getDecimalInfo(2,thisPrice)
					
					// 计算金额 单价*数量
					this.sendDataInfo.pspdMoney  =   this.$common.getDecimalInfo(3,NP.times(thisPrice,info.pspdPsnumber))
					
					// 计算含税金额 含税价格*数量
					this.sendDataInfo.pspdPsmoney  =   this.$common.getDecimalInfo(3,NP.times(info.pspdPsprice,info.pspdPsnumber))
					break;
				case 3:  // 通过总金额计算
					
					// 计算单价  总金额 / 数量
					var thisPrice = NP.divide(info.pspdMoney,info.pspdPsnumber)
					this.sendDataInfo.pspdPrice  =  this.$common.getDecimalInfo(2,thisPrice)
					
					// 计算含税价格 单价+单价*税率/100
					var thisPriceTwo = NP.plus(thisPrice,NP.divide(NP.times(thisPrice,info.pspdIntaxrate),100))
					this.sendDataInfo.pspdPsprice  =  this.$common.getDecimalInfo(3,thisPriceTwo)
					
					// 计算含税金额 含税价格*数量
					this.sendDataInfo.pspdPsmoney  =   this.$common.getDecimalInfo(3,NP.times(thisPriceTwo,info.pspdPsnumber))
					break;
					
				case 4:  // 通过含税金额计算
					
					// 计算含税价格  含税金额 / 数量
					var thisPrice = NP.divide(info.pspdPsmoney,info.pspdPsnumber)
					this.sendDataInfo.pspdPsprice  =  this.$common.getDecimalInfo(2,thisPrice)
					
					
					// 计算单价 含税价格/(税率/100+1)
					var thisPriceTwo = NP.divide(thisPrice,NP.plus(NP.divide(info.pspdIntaxrate,100),1))
					this.sendDataInfo.pspdPrice  =  this.$common.getDecimalInfo(2,thisPriceTwo)
					
					// 计算总金额 单价*数量
					this.sendDataInfo.pspdMoney  =   this.$common.getDecimalInfo(3,NP.times(thisPriceTwo,info.pspdPsnumber))
					break;
				default:  // 通过数量计算
					// 计算金额 单价*数量
					this.sendDataInfo.pspdMoney =   this.$common.getDecimalInfo(3,NP.times(info.pspdPrice,info.pspdPsnumber))
					// 计算含税金额 含税价格*数量
					this.sendDataInfo.pspdPsmoney  =   this.$common.getDecimalInfo(3,NP.times(info.pspdPsprice,info.pspdPsnumber))
					break;
			}
		},
		
		// 获取所有可用库房列表
		async getAllStorageRoom(){
			let responseData =  await this.$http.getAllStorageRoom()
			if(responseData.status == 200){
				this.storageRoomList = responseData.result
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		selectDataAction(data){
			this.sendDataInfo.bgmInternalcode = data.bgmId
			this.sendDataInfo.bgmName = data.bgmName
			this.sendDataInfo.bgmManufacturer = data.bgmManufacturer
			this.sendDataInfo.bgmSpecifications = data.bgmSpecifications
			this.sendDataInfo.bgmPlaceorigin = data.bgmPlaceorigin
			this.sendDataInfo.pspdIntaxrate = data.bgfIntaxrate
			this.sendDataInfo.pspdPsdvolume = data.rjXl
			this.sendDataInfo.pspdPslowerlimit = data.limdLownum
			this.sendDataInfo.pspdPsnvolume = data.stockNum
			this.sendDataInfo.pspdPsownumber = data.ztSl
			this.sendDataInfo.pspdPsupperlimit = data.limdHighnum
			this.sendDataInfo.stId = data.stId
			
			this.sendDataInfo.pspdMoney = 0
			this.sendDataInfo.pspdPrice = 0
			this.sendDataInfo.pspdPsmoney = 0
			this.sendDataInfo.pspdPsnumber = 0
			this.sendDataInfo.pspdPsprice = 0
			
			this.selectDataTable = false
			
		},
		initActionBox(){
			for(let key in this.sendDataInfo){
				this.sendDataInfo[key]  = ''
			}
			
			this.sendDataInfo.pspdIntaxrate = 0
			this.sendDataInfo.pspdMoney = 0
			this.sendDataInfo.pspdPrice = 0
			this.sendDataInfo.pspdPsmoney = 0
			this.sendDataInfo.pspdPsnumber = 0
			this.sendDataInfo.pspdPsprice = 0
			
			this.dataActionBox.actionType = 0
			this.dataActionBox.showStatus = false
		},
		async openBox(cate,formData,mainId,oldData=''){
			this.formData = formData
			// console.log(oldData)
			this.initActionBox()
			this.sendDataInfo.pspmId = mainId
			if(cate == 0){
				this.dataActionBox.boxTitle = '新增信息'
				this.dataActionBox.openMode = 'ltr'
			}else{
				this.dataActionBox.boxTitle = '编辑信息'
				this.dataActionBox.openMode = 'rtl'
				// console.log(oldData)
				for(let key in oldData){
					this.sendDataInfo[key]  = oldData[key]
				}
				this.sendDataInfo.pspdId = oldData.pspdId
				
			}
			this.dataActionBox.actionType = cate
			this.dataActionBox.showStatus = true
			
		},
		
	
		
		// 新增或修改
		async sendDataAction(){
			if(this.sendDataInfo.bgmInternalcode ==''){
				this.$message({
					message: '请选择商品',
					type: 'error'
				});
				return false
			}
			let sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
			if(this.dataActionBox.actionType==0){
				var responseData =  await this.$http.addPurchasePlanDetails(sendData)
			}else{
				var responseData =  await this.$http.editPurchasePlanDetails(sendData)
			}
			if(responseData.status == 200){
				this.$message({
					message: '操作成功',
					type: 'success'
				});
				this.initActionBox()
				this.$parent.getDataList()
				
				
				
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		
		
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
		this.getAllStorageRoom()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {
	}, //生命周期 - 创建之前
    beforeMount() {
	}, //生命周期 - 挂载之前
    beforeUpdate() {
	}, //生命周期 - 更新之前
    updated() {
	}, //生命周期 - 更新之后
    beforeDestroy() {
	}, //生命周期 - 销毁之前
    destroyed() {
	}, //生命周期 - 销毁完成
    activated() {
	}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style>

</style>